var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.1687 30.1748C37.2855 24.6058 36.8221 16.713 31.7784 11.6672C26.2244 6.11092 17.2195 6.11092 11.6655 11.6672C6.1115 17.2235 6.1115 26.2321 11.6655 31.7884C16.6775 36.8025 24.4997 37.2918 30.0602 33.2564L37.2631 40.3573C37.4571 40.5486 37.7691 40.5474 37.9617 40.3547L40.3548 37.9607C40.5494 37.7659 40.5483 37.4499 40.3522 37.2566L33.1687 30.1748Z",
    fill: "url(#paint0_linear_11184_60452)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6099 21.9385C31.6099 27.3786 27.2017 31.7886 21.7639 31.7886C16.3262 31.7886 11.918 27.3786 11.918 21.9385C11.918 16.4985 16.3262 12.0885 21.7639 12.0885C27.2017 12.0885 31.6099 16.4985 31.6099 21.9385Z",
    fill: "url(#paint1_linear_11184_60452)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11184_60452",
    x1: 11.6655,
    y1: 11.6672,
    x2: 38.8163,
    y2: 38.8068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.434971,
    stopColor: "#81A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E53FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11184_60452",
    x1: 16.6234,
    y1: 11.689,
    x2: 26.2011,
    y2: 31.7855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4FFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/매장찾기.fd6e926272f5313ace0ea521a3b9597d.svg";
export { ForwardRef as ReactComponent };